import { useEffect } from 'react';
import katex from 'katex';
import { stripArithmatexDelimiters } from './stripArithmatexDelimiters';

export function useRenderMathElements(mathElements: HTMLElement[]) {
  useEffect(() => {
    mathElements.forEach(el => {
      if (el.querySelector('.katex')) return;

      const rawText = el.textContent ?? '';
      const tex = stripArithmatexDelimiters(rawText);
      if (!tex) return;

      const displayMode = el.tagName === 'DIV';

      try {
        katex.render(tex, el, { displayMode, throwOnError: false });
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error('KaTeX render error:', e);
      }
    });
  }, [mathElements]);
}
